import {createLog} from './BannerCommon';
import {getBannerStatLogger} from './BannerStat';
import {JSEvaluator} from './JSEvaluator';

const evaluator: JSEvaluator = new JSEvaluator();

const FIND_PLACE_DEPTH = 5;
const ERROR_MESSAGE_LEN = 64;

evaluator.logError = (script: HTMLScriptElement, error: Error) => {
    const errorName = error.name || 'unknown';
    const jsplace = JSEvaluator.findNearestPlace(script, FIND_PLACE_DEPTH) || 'unknown';
    let message = errorName;
    if (error.message) {
        message += ': ' + error.message.substring(0, ERROR_MESSAGE_LEN);
    }
    getBannerStatLogger().trace('adScriptErrorData', error.stack!, 'jsban_' + jsplace, message);
};

export class HtmlRenderer {

    log = createLog('HtmlRenderer');

    setBannerPlace(element: HTMLElement, position: number | string) {
        element.setAttribute(JSEvaluator.JSPLACE_ATTR_NAME, 'p' + position);
    }

    setBannerHtml(element: HTMLElement, html: string) {
        this.log('setBannerHtml', {
            el: element,
            html: html
        });
        element.innerHTML = html;
        evaluator.findAndEvalScripts(element);
    }
}
